import Vuex from 'vuex';
import Vue from 'vue';
import User from './user/index';
import userAccount from './user/userAccount';
import userForm from './user/userForm';
import patientsNfzList from './patietns/patientsNfzList';
import reservationStats from './reservation/reservationStats';
import patientsDiagnosis from './patietns/patientsDiagnosis';
import patientsInformation from './patietns/patientsInformation';
import patientsOpinionsList from './patietns/patientsOpinionsList';
import reservationList from './reservation/reservationList';
import patientsDecisions from './patietns/patientsDecisions';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: User,
    userAccount,
    userForm,
    reservationStats,
    reservationList,
    patientsDiagnosis,
    patientsOpinionsList,
    patientsInformation,
    patientsNfzList,
    patientsDecisions
  }
});
